Ext.ns('mx.comp');

mx.comp.FormLayout = Ext.extend(Ext.layout.FormLayout, {
    defaultLabelWidth: 100,

    tipWidth: 20,

    fieldTpl: new Ext.Template(
        '<div class="x-form-item mx-comp-formlayout-form-item {5}" tabIndex="-1">',
        '{8}',
        '<label for="{0}" style="{2}" class="x-form-item-label">{1}{7}{4}</label>',
        '<div class="x-form-element" id="x-form-el-{0}" style="{3}">',
        '</div><div class="{6}"></div>',
        '</div>',
        {disableFormats: true}
    ).compile(),

    renderItem: function(c, position, target) {
        if (c && !c.rendered && (c.isFormField || c.pretendToBeFormField) && c.inputType != 'hidden' && !c.noLabel) {
            var args = [
                c.id, // 0
                c.fieldLabel, // 1
                c.labelStyle || this.labelStyle || '', // 2
                this.elementStyle || '', // 3
                typeof c.labelSeparator == 'undefined' ? this.labelSeparator : c.labelSeparator, // 4
                (c.itemCls || this.container.itemCls || '') + (c.hideLabel ? ' x-hide-label' : ''), // 5
                c.clearCls || 'x-form-clear-left', // 6
                c.allowBlank === false ? '<span class="mx-comp-formlayout-asterix">*</span>' : '', // 7
                c.hint ? '<div class="mx-comp-formlayout-question" ext:qtip="' + c.hint + '"></div>' : '', // 8
            ];
            if (typeof position == 'number') {
                position = target.dom.childNodes[position] || null;
            }
            if (position) {
                this.fieldTpl.insertBefore(position, args);
            } else {
                this.fieldTpl.append(target, args);
            }
            c.render('x-form-el-' + c.id);
        } else {
            Ext.layout.FormLayout.superclass.renderItem.apply(this, arguments);
        }
    },

    setContainer: function(ct) {
        if (ct.labelAlign) {
            ct.addClass('x-form-label-' + ct.labelAlign);
        }

        if (ct.hideLabels) {
            this.labelStyle = 'display:none';
            this.elementStyle = 'padding-left:0;';
            this.labelAdjust = 0;
        } else {
            this.labelSeparator = ct.labelSeparator || this.labelSeparator;
            ct.labelWidth = ct.labelWidth || this.defaultLabelWidth;
            if (typeof ct.labelWidth == 'number') {
                var pad = typeof ct.labelPad == 'number' ? ct.labelPad : 5;
                this.labelAdjust = ct.labelWidth + pad + this.tipWidth;
                this.labelStyle = 'width:' + ct.labelWidth + 'px;';
                this.elementStyle = 'padding-left:' + this.labelAdjust + 'px';
            }
            if (ct.labelAlign == 'top') {
                this.labelStyle = 'width:auto;';
                this.labelAdjust = 0;
                this.elementStyle = 'padding-left:0;';
            }
        }
        Ext.layout.FormLayout.superclass.setContainer.call(this, ct);
    },

    // private
    adjustWidthAnchor: function(value, comp) {
        if (comp.insistWidth) {
            return comp.insistWidth;
        } else {
            return (
                value -
                (comp.isFormField ? (comp.hideLabel ? 0 : this.labelAdjust) : 0) -
                (comp.insistMarginRight ? comp.insistMarginRight : 0)
            );
        }
    },
});

Ext.Container.LAYOUTS['mx-form'] = mx.comp.FormLayout;
